import { Progress } from "antd";

export function CompletionBarInline({ percent }: { percent: number }) {
  const safe = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div style={{ position: "relative" }}>
      <Progress
        percent={safe}
        showInfo={false}
        type="line"
        strokeLinecap="round"
        strokeWidth={50}
        strokeColor={{ "0%": "rgba(24, 28, 132, 1)", "100%": "rgba(243, 16, 158, 1)" }}
        trailColor="#1f1f1f"
        style={{ borderRadius: 999 }}
      />
      <div style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        color: "#ffffff",
        pointerEvents: "none",
        height: "40px",
      }}>
        {safe}%
      </div>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: 12,
        color: "#8c8c8c",
        marginTop: 4
      }}>
        <span>Not Started</span>
        <span>100%</span>
      </div>
    </div>
  );
}
export default CompletionBarInline;